import { cn } from '../lib/utils'

/** Jump link for keyboard users, visible only while focused. Point it at the `<main id>`. */
export function SkipLink({
  href = '#main',
  className,
  children,
}: {
  href?: string
  className?: string
  children: React.ReactNode
}) {
  return (
    <a
      href={href}
      className={cn(
        'sr-only z-50 rounded-md border border-line-strong bg-surface px-3 py-2 font-semibold text-ink text-sm focus:not-sr-only focus:absolute focus:top-3 focus:left-4',
        className,
      )}
    >
      {children}
    </a>
  )
}
